import { getBaseDomain } from '../utils/domain';
import Cookies from 'universal-cookie';

interface SetterObject {
  affiliatePartner?: string;
  affiliateProvider?: string;
  affiliateToken?: string;
  affiliateRedirectUrl?: string;
}

const camelToSnakeCase = (str: string) =>
  str.replace(/[A-Z]/g, (letter: string) => `_${letter.toLowerCase()}`);

const cookies = new Cookies();
const cookieLifetime = 604800; // 604800 = 7 days
const domain = getBaseDomain();

export const set = (data: SetterObject) => {
  Object.keys(data).forEach((key) => {
    const value = data[key as keyof SetterObject];

    cookies.set(camelToSnakeCase(key), value || '', {
      path: '/',
      maxAge: cookieLifetime,
      domain,
    });
  });
};

export const get = (key: keyof SetterObject) => {
  return cookies.get(key as string);
};

export const getAll = (): SetterObject => ({
  affiliateProvider: cookies.get('affiliate_provider'),
  affiliatePartner: cookies.get('affiliate_partner'),
  affiliateToken: cookies.get('affiliate_token'),
  affiliateRedirectUrl: cookies.get('affiliate_redirect_url'),
});
